<template>
  <div>
    <div ref="overviewChart"></div>
    <v-col md="6">
      <v-select
        :value="dataType"
        :items="itemsFilters"
        :label="$t('commons.filters')"
        outlined
        @change="onSelectChange"
      ></v-select>
    </v-col>
  </div>
</template>

<script>
import { toISODate } from "@/utils/datetime"
import { makeChartOptions, makeChartObj, updateChartObj } from "@/utils/charts"

export default {
  name: "Overview",
  props: {
    inspections: {
      type: Array
    },
    nonConformities: {
      type: Array
    }
  },
  data() {
    return {
      dataType: "Inspections",
      chart: null,
      itemsFilters: [
        "Inspections",
        "Inspections ongoing",
        "Inspections without nonconformity",
        "Nonconformities"
      ]
    }
  },
  computed: {
    isThemeDark() {
      return this.$store.state.app.isThemeDark
    }
  },
  methods: {
    onSelectChange(newValue) {
      this.dataType = newValue
      this.updateChart()
    },
    getChartOptions(series) {
      return makeChartOptions({
        chart: { height: 400, type: "bar" },
        isThemeDark: this.isThemeDark,
        series: series,
        titleText: this.dataType,
        tooltip: { x: { format: "dd MMM yyyy" } },
        xaxis: { type: "datetime" }
      })
    },
    getSeries() {
      let data = []
      switch (this.dataType) {
        case "Inspections": {
          data = this.inspections
          break
        }
        case "Inspections ongoing": {
          data = this.inspections.filter(item => item.status == "Ongoing")
          break
        }
        case "Inspections without nonconformity": {
          data = this.inspections.filter(item => item.children == 0)
          break
        }
        case "Nonconformities": {
          data = this.nonConformities
          break
        }
      }
      const sorted = this.sortByDate(data)
      return [
        {
          name: "Inspections",
          data: Object.entries(sorted).map(e => [e[0], e[1].length])
        }
      ]
    },
    makeChart() {
      const series = this.getSeries(this.dataType)
      const options = this.getChartOptions(series)
      this.chart = makeChartObj(this.$refs.overviewChart, options)
    },
    updateChart() {
      const series = this.getSeries(this.dataType)
      const options = this.getChartOptions(series)
      updateChartObj(this.chart, options)
    },
    sortByDate(data) {
      return data.reduce((groups, item) => {
        const date = toISODate(item.date)
        if (!groups[date]) {
          groups[date] = []
        }
        groups[date].push(item)
        return groups
      }, {})
    }
    // getChartOptions(data, title) {
    //   return {
    //     noData: { text: "No data found." },
    //     colors: ["#Ff444c", "#94c41c", "#481c74", "#00B0FF", "#FFC565", "#9F88B1", "#6F0400"],
    //     markers: {
    //       size: 6,
    //       strokeWidth: 2,
    //       shape: "circle"
    //     },
    //     fill: {
    //       opacity: 0.8
    //     },
    //     stroke: {
    //       curve: "straight"
    //     },
    //     title: {
    //       text: title,
    //       align: "center",
    //       offsetY: -8,
    //       style: {
    //         fontSize: "20px",
    //         fontWeight: "bold",
    //         color: this.color
    //       }
    //     },
    //     chart: {
    //       height: 400,
    //       type: "bar"
    //     },
    //     legend: {
    //       show: true,
    //       position: "top",
    //       horizontalAlign: "center",
    //       fontSize: "14px",
    //       onItemHover: {
    //         highlightDataSeries: true
    //       }
    //     },
    //     xaxis: {
    //       type: "datetime",
    //       labels: {
    //         style: { colors: this.color }
    //       }
    //     },
    //     tooltip: {
    //       x: {
    //         format: "dd MMM yyyy"
    //       }
    //     },
    //     yaxis: {
    //       min: 0,
    //       title: {
    //         text: "Count",
    //         rotate: -90,
    //         style: {
    //           color: this.color,
    //           fontSize: "12px",
    //           fontFamily: "Helvetica, Arial, sans-serif",
    //           fontWeight: 600,
    //           cssClass: "apexcharts-yaxis-title"
    //         }
    //       },
    //       labels: {
    //         style: { colors: this.color }
    //       }
    //     },
    //     series: [
    //       {
    //         name: "Inspections",
    //         data: data
    //       }
    //     ]
    //   }
    // }
  },
  mounted() {
    this.makeChart()
  },
  watch: {
    inspections: {
      deep: true,
      handler() {
        this.updateChart()
      }
    },
    isThemeDark: {
      handler() {
        this.updateChart()
      }
    }
  }
}
</script>
